import React from 'react';

class UnderConstruction extends React.Component {


	render() {
		return (
			<div className="UnderConstruction">
				<img src={process.env.PUBLIC_URL + "images/under_construction.png"} alt={'Construction Cone'} />
				<div className="UnderConstruction-Text">
					We are working on building this page and will update you when it is available.
				</div>
			</div>
		);
	}
}

export default UnderConstruction;